import { Ability, type RawRuleOf } from '@casl/ability';

import type { MeResponseDto } from '@api/common-api.ts';

import { permissions } from './permissions.ts';
import type { Action, Entity } from './types.ts';

export type AppAbility = Ability<[Action, Entity]>;
type PermissionSource = Pick<MeResponseDto, 'permissions'> | null | undefined;

/** Builds CASL rules from exact permission names; role names never grant implicit access. */
export const createAppAbility = (user: PermissionSource): AppAbility => {
  const grantedPermissions = new Set(user?.permissions ?? []);
  const rules: RawRuleOf<AppAbility>[] = [];

  for (const [entity, actions] of Object.entries(permissions)) {
    for (const action of actions) {
      if (grantedPermissions.has(`${entity}:${action}`)) {
        rules.push({ action, subject: entity as Entity });
      }
    }
  }

  return new Ability<[Action, Entity]>(rules);
};

/** Users without permissions retain only their own profile, regardless of assigned roles. */
export const hasPortalPermissions = (user: PermissionSource): boolean =>
  Boolean(user?.permissions?.length);
